import { Pipe, PipeTransform } from '@angular/core';
import { ProductCostMethod, PRODUCT_COST_METHOD_LABELS } from '../product-costs.model';

@Pipe({
	name: 'productCostMethodLabel',
	standalone: true,
	pure: true,
})
export class ProductCostMethodLabelPipe implements PipeTransform {
	transform(value: ProductCostMethod | null | undefined): string {
		if (value == null) {
			return '-';
		}
		return PRODUCT_COST_METHOD_LABELS[value] ?? value;
	}
}
